export function titleCase(value: string | unknown): string {
  if (typeof value !== 'string') {
    return '';
  }

  const words: string[] = value.split(' ');

  const titleCasedWords: string[] = words.map((word: string): string => {
    if (word.length === 0) {
      return word;
    }

    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return titleCasedWords.join(' ');
}
